@if (dates(); as dates) {
  <nk-date-range [dates]="dates"></nk-date-range>
}
